import './PrayerInstructions.css';

const VALID_KEYS = ["crucifix", "medallion", "largebead", "smallbead"];

function getImageWidth(imageKey) {
	switch (imageKey) {
		case "crucifix":
			return 124;
		case "medallion":
			return 85;
		case "largebead":
			return 60;
		case "smallbead":
			return 50;
		case "chain": // No image (reserve flex-basis space for the chain)
			return 0;
		case "": // No image (don't reserve flex-basis space)
			return 0;
		default:
			console.warn(`Invalid imageKey: ${imageKey}. Valid keys are: ${VALID_KEYS.join(", ")}`);
			return 0; // Hide this image if the key is invalid
	}
}

const PrayerInstructions = ({ instructions = [] }) => {
	return (
		<div className='instr-set'>
			{instructions.map((item, index) => {
				const imgSource = "/static/images/prayer/" + item.imageKey + ".png";
				const imgWidth = getImageWidth(item.imageKey);
				const hasImage = item.imageKey !== "";
				const isLastItem = index === instructions.length - 1;
				const isFalseEnding = isLastItem && item.falseEnding;
				return (
					<div key={index} className="instr-row">
						<div className={`instr-img ${hasImage ? "" : "no-image-specified"}`}>
							{hasImage && (
								<img src={imgSource} alt={item.imageKey} style={{ maxWidth: `${imgWidth}px` }} />
							)}
						</div>
						<div className={`instr-desc ${isFalseEnding ? "false-ending-spacing" : (isLastItem ? "true-ending-shading" : "")}`}>
							<h3 className='leftaligned'>{item.title}</h3>
							{item.descriptionElements}
						</div>
					</div>
				);
			})}
		</div>
	);
}

export default PrayerInstructions;